<template>
    <div>
      <div class="align-content-center align-items-center animated d-flex fadeIn h-100 justify-content-center position-fixed w-100 line-item-modal">
        <div class="bg-white mx-auto rounded shadow p-5 text-center cu-width-input">
          <!-- <div v-if="values && values.length"> -->
            <div v-for="(field, index) in values" :key="index">
              <div class='d-flex justify-content-between align-items-center mb-2'>
                <p>{{ field.value }} ({{ field.date }})</p>
                <button
                    type='button' 
                    className='btn btn-icon btn-outline-danger' 
                    :style="{ background: 'none !important', border: 'none !important', cursor: 'pointer !important'}"
                >
                    <i 
                        class='fa fa-pencil text-primary mr-2'
                        :style="{fontSize: '1.2rem'}"
                        @click="editing = true; editingField = field; value = field.value; date = field.date; id = field.id"
                    >
                    </i>
                    <i 
                        class='fa fa-trash text-danger'
                        :style="{fontSize: '1.2rem'}"
                        @click="removeValue(field.id)" 
                    >
                    </i>
                </button>
              </div>
            </div>
          <!-- </div> -->

          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label for="value">Value</label>
                <div class="input-group">
                    <input v-model="value" class="form-control">
                    <div class="input-group-append" v-if="editing">
                        <button class="btn btn-light btn-border" type="button" @click="clear">Clear</button>
                    </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label for="date">Date</label>
                <flat-pickr v-model="date" class="form-control"></flat-pickr>
              </div>
            </div>
           </div>

          <div class="pt-3">
            <button @click="update" type="button" class="btn btn-primary mr-2" :disabled="!date || !value" >
              {{ editing ? 'Update' : 'Add' }}
            </button>
            <button @click="close(values)" type="button" class="btn btn-danger mr-2">
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'DynamicFieldModal',
    props: ['close', 'field_values'],
    data() {
      return {
        id: null,
        value: '',
        date: new Date().toISOString().substr(0, 10),
        values: this.field_values,
        editing: false, 
        editingField: null
      }
    },
  
    methods: {
      removeValue(field_id) {
        this.values = this.values.filter(item => item.id != field_id);
      },

      update() {
        if (this.editing) {
          this.values = this.values.map(item => {
            if (item.id == this.id) {
              return {
                id: this.id,
                value: this.value,
                date: this.date
              }
            }
            return item;
          });
        } else {
          this.values.push({
            id: this.values.length + 1,
            value: this.value,
            date: this.date
          });
        }
        this.value = '';
        this.date = new Date().toISOString().substr(0, 10);
        this.editing = false;
        this.editingField = null;
        this.id = null;
      },

      clear() {
        this.value = '';
        this.date = new Date().toISOString().substr(0, 10);
        this.editing = false;
        this.editingField = null;
        this.id = null;
      }
    },
  }
  </script>